import { action } from 'satcheljs/lib/legacy';
export default action('updateRecipientList')(function updateRecipientList(recipientWell, recipients) {
    recipientWell.recipients = recipients;
});
//# sourceMappingURL=updateRecipientList.js.map